import type { CoachDefinition, CoachId } from '../../types';
import { C01 } from './C01';
import { C02 } from './C02';
import { C03 } from './C03';
import { C04 } from './C04';
import { C05 } from './C05';
import { C06 } from './C06';
import { C07 } from './C07';
import { C08 } from './C08';

/**
 * The guided workflow coaches (Layer B, TASK §11): a finite set of local
 * definitions — never a remotely supplied selector or script — each filtered
 * per person by `coach.ts` from the same permission hooks the UI uses.
 *
 * The finite catalogue includes sourcing and purchase-order management; each
 * coach is offered only to an actor who can complete its page-owned actions.
 */
export const COACHES: readonly CoachDefinition[] = [C01, C02, C03, C04, C05, C06, C07, C08];

export function coachById(id: CoachId): CoachDefinition | undefined {
  return COACHES.find((coach) => coach.id === id);
}
